<template>
    <ModalDefault id="form-diligenciar-documento" size="xl" :title="docSeleccionadoValue?.cofoNombre">
      <template #modal-body>
        <div class="py-5 px-5">
          <div class="grid grid-cols-2 gap-4">
            <div v-if="loading">
                <SpinnerDefault size-spinner="size-12"/>
            </div>
            <div v-else-if="!loading && pdf" :style="{ width: '100%', height: '600px'}">
              <iframe width="100%" height="800px" :src="pdf"></iframe>
            </div>
            <div v-else>
              <alert-default
                :color="'blue'"
                titulo="Documento no cargo correctamente!"
                icono="InformationCircleIcon">
                <span class="caption">Contactar con soporte.</span>
              </alert-default>
            </div>
            <div>
                <DocumentosFormParametros
                  v-if="docSeleccionadoValue && docSeleccionadoValue.parametros && docSeleccionadoValue.parametros.filter(e => e.cdjpInForm).length > 0"
                  :parametros="docSeleccionadoValue.parametros.filter(e => e.cdjpInForm)"
                  :aplicar-cambios="aplicarParametros"
                  />
                  <div class="my-2"></div>
                <DocumentosFirma :set-firmas="setFirmas">
                  <template #buttons="{ firma }">
                    <slot name="firmabuttons" v-bind="{firma}"></slot>
                  </template>
                </DocumentosFirma>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <ButtonDefault v-if="!loading && pdf" color="blue" :is-loading="saving" @click="guardarDocumento">Guardar documento</ButtonDefault>
      </template>
    </ModalDefault>
</template>
<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import DocumentosFirma from './DocumentosFirma.vue'
import type { TDocumentDefinitions } from 'pdfmake/interfaces'
import type { IConfDocjsonDili } from '../../interfaces';
import { useDocumentosPdf } from '@/modules/Configuracion/composables/useDocumentosPdf';
import { docJsonDiligenciadosService } from '@/services';
import type { ICitaDocjson } from '@/modules/Asistencial/interfaces';
import stringifyObject from 'stringify-object'
import { useDocumentosDiligenciar } from '../../composables/useDocumentosDiligenciar';
import DocumentosFormParametros from './DocumentosFormParametros.vue';
import type { IConfDocjsonparametrosForm } from '../../interfaces/tablas/IConfDocjsonparametros';
import { closeModal } from '@/modules/Core/usings/generales';
const { createPdf, generarStructuraCompleta } = useDocumentosPdf()
const { setDiligenciado, getDiligenciados } = useDocumentosDiligenciar()

const loading = ref(true)
const saving = ref(false)
const props = defineProps<{
  docSeleccionado: IConfDocjsonDili | null
}>()
const docSeleccionadoValue = ref(props.docSeleccionado)

const pdf = ref<string | null>(null)
const firmas = ref<{ firmas: TDocumentDefinitions['content'], images: TDocumentDefinitions['images'], columnas: unknown[] }>()
onMounted(async ()=>{
  if (docSeleccionadoValue.value) {
    loading.value = true
    await createPdf({ doc: docSeleccionadoValue.value, pdf, withParams: true })
    loading.value = false
  }
})
const setFirmas = async (data: TDocumentDefinitions['content'], images: TDocumentDefinitions['images'], columnas: unknown[]) => {
  loading.value = true
  firmas.value = { firmas: data, images, columnas }
  await recargarPdf()
  loading.value = false
}
const recargarPdf = async () => {
  if (docSeleccionadoValue.value) {
    await createPdf({ doc: docSeleccionadoValue.value, pdf, withParams: true, firmas: firmas.value })
  }
}
const aplicarParametros = async (parametros: IConfDocjsonparametrosForm[]) => {
  docSeleccionadoValue.value?.parametros?.forEach(item => {
    const exist = parametros.find(e => e.cdjpNombre == item.cdjpNombre)
    if(exist) item.valor = exist.valor
  })
  await recargarPdf()
}
const efectuarGuardarDocumento = async () => {
  if (saving.value) return
  saving.value = true
  try {
    window.notificacion.loading().circle()
    if (docSeleccionadoValue.value) {
      const result = await generarStructuraCompleta({ doc:docSeleccionadoValue.value,  withParams: true, withHeader: docSeleccionadoValue.value.cofoHeader !== 0, withFooter: docSeleccionadoValue.value.cofoFooter !== 0, firmas: firmas.value})
      if (!pdf.value && !result) {
        window.notificacion.notificacion('failure',
          'Documento no valido'
        )
        return
      }
      const newForm = {
        cifoTipoDocumento: docSeleccionadoValue.value.cofoTipoDocumento,
        cifoCodigo: docSeleccionadoValue.value.cofoCodigo,
        cifoNombre: docSeleccionadoValue.value.cofoNombre,
        tablaId: docSeleccionadoValue.value.tablaId,
        tablaOrigen: docSeleccionadoValue.value.tablaOrigen,
        cifoSitioDiligencia: docSeleccionadoValue.value.cofoSitioDiligencia,
        cifoJson: stringifyObject(result, { indent: '  ' }),
        cifoHeader: docSeleccionadoValue.value.cofoHeader,
        cifoFooter: docSeleccionadoValue.value.cofoFooter
      } as ICitaDocjson
      if(docSeleccionadoValue.value.tablaId){
        await docJsonDiligenciadosService.create(newForm)
        await getDiligenciados({ tablaId: newForm.tablaId as number, tablaOrigen: newForm.tablaOrigen as string, cofoTipoDocumento: newForm.cifoTipoDocumento as string } )
      } else {
        setDiligenciado(newForm)
      }
      window.notificacion.notificacion('success', "registrado");
      closeModal('form-diligenciar-documento')
    }
  } finally {
    saving.value = false
    window.notificacion.loading().remove()
  }
}
const guardarDocumento = async () => {
  if (!firmas.value) {
        window.notificacion.confirmacion(
          'Importante!',
          'No ha agregado firmas o elementos requeridos en el documento, ¿Desea continuar sin agregar estos elementos?',
          async () => { await efectuarGuardarDocumento() },
          () => {}
        )
    return
  }
  await efectuarGuardarDocumento()
}
onBeforeUnmount(() => {
  if (pdf.value) URL.revokeObjectURL(pdf.value);
});
</script>
